<template>
  <div id="app" class="wrapper">
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper" ref="topo">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <div
          style="padding-right: 0px; padding-left: 0px"
          class="container-fluid"
        >
          <div class="row mb-2">
            <div class="col-sm-6">
              <!--<h1>Produtos</h1>	-->
            </div>
            <div class="col-sm-6"></div>
          </div>
        </div>
        <!-- /.container-fluid -->
      </section>

      <!-- Main content -->
      <section class="content">
        <div
          style="padding-right: 0px; padding-left: 0px"
          class="container-fluid"
        >
          <div class="form-group">
            <div id="app">
              <br />
              <div
                style="
                  justify-content: center;
                  display: flex;
                  flex-flow: row nowrop;
                  align-items: center;
                "
              >
                <img
                  v-bind:src="
                    'https://apppanterafood.com.br/DeliveryCenter/' +
                    retornaContrato +
                    '/logo/topo_deli.jpg'
                  "
                />
              </div>
              <br />
              <div style="padding: 0" class="container">
                <!--          <h2 align="center">Cardápio</h2-->
                <ul style="margin: 0" class="list-group">
                  <li
                    style="border: none; margin-bottom: -1px; padding: 0"
                    class="list-group-item"
                    v-for="(classe, index) in classe_prods"
                    :key="classe.nm"
                    :id="index"
                    :ref="classe.nm_id"
                  >
                    <div>
                      <div
                        :style="{
                          textAlign: 'center',
                          fontSize: '1.5rem',
                          color: corClasse,
                          backgroundColor: corBotao,
                        }"
                        type="div"
                        class="btn-lg btn-block btn-secondary btn-dark"
                        :id="classe.nm_id"
                        @click="abrirFechar($event)"
                      >
                        {{ classe.nm }}
                      </div>
                      <img
                        v-bind:src="urlImage(contrato, classe.nm)"
                        @error="erroImagem($event)"
                        @click="abrirFechar($event)"
                        :class="classe.nm_id.split(' ').join('')"
                        :id="classe.nm_id"
                      />
                    </div>
                    <!-- @load="abriuImagem($event)" -->

                    <ul
                      style="margin: 0"
                      class="border-bottom border-top"
                      id="myList"
                      v-if="mostrarProduto && classeClicada == classe.nm_id"
                    >
                      <li
                        :style="{
                          border: 'none',
                          marginTop: '1px',
                          backgroundColor: corFundo,
                        }"
                        class="list-group-item border-bottom seletor"
                        v-if="produto.classe == classe.nm"
                        v-for="produto in products"
                        :key="produto.cd"
                        @click="
                          verificaordemprod(produto.cd, produto.nm, produto),
                            (cdproduto = produto.cd),
                            (nmproduto = produto.nm),
                            (vlproduto = produto.vl),
                            (ingredientesproduto = produto.ingredientes),
                            (classeproduto = produto.classe),
                            listandoordem(
                              produto.cd,
                              produto.nm,
                              produto.classe,
                              produto.ingrediente,
                              produto.vl,
                              nome_ordem.cd,
                              nome_ordem.cd_prod,
                              nome_ordem.nm,
                              nome_ordem.ordem,
                              nome_ordem.selecao
                            )
                        "
                      >
                        <div style="display: flex">
                          <div style="width: 100%; padding-right: 5px">
                            <label
                              :style="{ fontSize: 'large', color: corTexto }"
                              class="cor-preta"
                            >
                              <b>{{ produto.nm }}</b
                              ><br />
                              <!-- <b>{{ produto.classe }}</b
                              > -->
                            </label>

                            <label
                              class="cor-cinza letra-pequena mt-2"
                              :style="{
                                color: corDescricao,
                              }"
                              >{{ produto.ingredientes }}</label
                            >
                            <br />
                            <b style="color: #df0000; font-size: large">
                              <span
                                v-if="
                                  produto.vl_promo > 0 &&
                                  produto.classe.toUpperCase() !== 'PIZZAS'
                                "
                                class="promo-price"
                              >
                                <span class="risquinho">
                                  R$ {{ produto.vl }}
                                </span>
                                R$ {{ produto.vl_promo }}
                                <!-- valor de promoção -->
                              </span>
                              <span v-else-if="produto.classe.toUpperCase() == 'PIZZAS'">
                                <span v-if="tipoPizza != '1'">
                                  A Partir de R$: {{ produto.vl }}
                                </span>
                                <span v-else>
                                  R$: {{ produto.vl }}
                                </span>
                              </span>
                              <span v-else> R$ {{ produto.vl }} </span>
                            </b>
                            <!-- <span class="cor-branca fundo p-1">
                            </span> -->
                            <br />
                            <br />
                          </div>

                          <picture align="right">
                            <img
                              style="
                                max-width: 100px;
                                max-height: 100px;
                                width: 100px;
                                height: 100px;
                              "
                              class="img-circular img-tam"
                              v-bind:src="
                                urlImageProduto(retornaContrato, produto.cd)
                              "
                              v-bind:alt="produto.cd"
                              @error="erroImagemProduto($event)"
                            />
                          </picture>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <a
          id="irTopo"
          style="
            position: fixed;
            bottom: 30px;
            right: 20px;
            color: #fff !important;
            background-color: #006400;
          "
          class="btn btn-dark"
          @click="scrollMeTo('topo')"
          >Topo</a
        >
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Inis from "../services/inis";
import Classe_prod from "../services/classe_prod";
import Ordem from "../services/nome_ordem";
import SecureLS from "secure-ls";
var ls = new SecureLS({ encodingType: "aes" });

export default {
  name: "Products",
  data() {
    return {
      checkedNames: [],
      adicionaispergunta: [],
      search: "",
      classe_prods: [],
      classe_prod: {
        nm: "",
        ordem: "",
      },
      product: {
        cd: "",
        nm: "",
        classe: "",
        ingredientes: "",
        vl: "",
      },
      nome_ordens: [],
      nome_ordem: {
        cd: "",
        nm: "",
        ordem: "",
        cd_prod: "",
        selecao: "",
      },
      //adicionais: [],
      adicional: {
        cd: "",
        cd_prod: "",
        qtd: "",
        vl: "",
        tipo: "",
        nm: "",
        cd_sabor: "",
        ordem: "",
        obs: "",
        cd_prod_pai: "",
      },
      corBotao: "",
      corTexto: "",
      corFundo: "",
      corClasse: "",
      corDescricao: "",
      cdproduto: "",
      nmproduto: "",
      vlproduto: "",
      ingredientesproduto: "",
      classeproduto: "",
      index: 0,
      classes: [],
      classesNomes: [],
      classesNomes2: [],
      mostrarProduto: false,
      classeClicada: "",
      arrayMostrarProduto: [],
      errosImagem: [],
      contrato: "",
      estoque: "",
      ordemAlfabetica: 0,
      tipoPizza: "",
    };
  },
  computed: {
    retornaContrato() {
      this.contrato = localStorage.getItem("contrato");
      return this.contrato;
    },
    ...mapGetters({
      //adicionais: 'allAdicionais',
      products: "allProducts",
      length: "getNumberOfProducts",
    }),
    //pesquisar QRCODE
  },
  methods: {
    urlImage(contrato, classe) {
      let encodedNm = Buffer.from(classe).toString("base64");
      return `https://apppanterafood.com.br/DeliveryCenter/${contrato}/classes/${encodedNm}.jpg?${performance.now()}`;
    },
    urlImageProduto(contrato, prod) {
      let encodedNm = Buffer.from(prod).toString("base64");
      return `https://apppanterafood.com.br/DeliveryCenter/${contrato}/produtos/${prod}.jpg?${performance.now()}`;
    },
    verificaordemprod(cd, nm, product) {
      Ordem.verificaordem(cd).then((resposta) => {
        if (product.classe.toUpperCase() == "PIZZAS") {
          ls.set(
            "product" + localStorage.getItem("contrato"),
            JSON.parse(JSON.stringify(product))
          );
          this.$router.push("/perguntaspizza");
        } else if (resposta.data === null || resposta.data.length === 0) {
          //alert(JSON.stringify(product));

          if (product.vl_promo > 0) {
            product.vl = product.vl_promo;
          }
          ls.set(
            "product" + localStorage.getItem("contrato"),
            JSON.parse(JSON.stringify(product))
          );

          //window.location = 'https://localhost:8080/produtounico';
          /*  window.location = "https://192.168.1.27:8080/produtounico"; */
          //window.location = 'https://192.168.1.27/cardapio/produtounico';
          this.$router.push("/produtounico");

          // window.location = "https://apppanterafood.com.br/DeliveryCenter/3/cardapio/produtounico";
        } else {
          //alert(JSON.stringify(product));
          //alert(JSON.stringify(product));
          if (product.vl_promo > 0) {
            product.vl = product.vl_promo;
          }
          ls.set(
            "product" + localStorage.getItem("contrato"),
            JSON.parse(JSON.stringify(product))
          );

          this.$router.push("/perguntas");
          //window.location = 'https://localhost:8080/perguntas';
          /*   window.location = "https://192.168.1.27:8080/perguntas"; */
          //window.location = 'https://192.168.1.27/cardapio/perguntas';

          //window.location ="https://apppanterafood.com.br/DeliveryCenter/3/cardapio/perguntas";
        }
      });
    },
    scrollMeTo(refName) {
      var element = this.$refs[refName];

      var top = element.offsetTop;

      element.scrollIntoView({ behavior: "smooth" });
    },
    scrollArray(refName) {
      var element = this.$refs[refName];

      var top = element[0].offsetTop;

      element[0].scrollIntoView({ behavior: "smooth" });
    },
    listarclasse() {
      Classe_prod.listarclasse().then((resposta) => {
        this.classe_prods = resposta.data;
        this.classe_prods.map((classe) => {
          var id;
          id = classe.nm;
          id = id.replace(/[áàãâä]/iu, "a");
          id = id.replace(/[éèêë]/iu, "e");
          id = id.replace(/[íìîï]/iu, "i");
          id = id.replace(/[óòõôö]/iu, "o");
          id = id.replace(/[úùûü]/iu, "u");
          id = id.replace(/[ç]/iu, "c");
          id = id.replace(/[^a-zA-Z 0-9]+/g, "");
          id = id.replace(/_+/, "");
          id.toUpperCase();

          classe.nm_id = id;
        });
      });
    },

    erroImagemProduto(event) {
      event.target.src =
        "https://apppanterafood.com.br/DeliveryCenter/" +
        this.retornaContrato +
        "/produtos/sem_imagem.jpg";
    },
    erroImagem(e) {
      var classe = e.target.id;

      document.querySelector("." + classe.split(" ").join("")).remove();

      /* activeDiv.classList.add('hidden'); */
    },

    abrirFechar(e) {
      if (this.classeClicada == e.target.id) {
        this.mostrarProduto = !this.mostrarProduto;
      } else {
        this.mostrarProduto = true;
        this.classeClicada = e.target.id;
      }
      this.scrollArray(e.target.id);
    },

    listandoInis() {
      var cd = "CONTROLA_ESTOQUE";
      Inis.listarInisCd(cd).then((resposta) => {
        this.estoque = resposta.data[0].vl;
      });
      var cd = "Cor_primaria";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corFundo = resposta.data[0].vl;
      });
      var cd = "Cor_secundaria";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corBotao = resposta.data[0].vl;
      });
      var cd = "Cor_tercearia";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corTexto = resposta.data[0].vl;
      });
      var cd = "COR_CLASSE";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corClasse = resposta.data[0].vl;
      });
      var cd = "COR_DESCRICAO ";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corDescricao = resposta.data[0].vl;
      });
      var cd = "ID_PIXEL";
      Inis.listarInisCd(cd).then((resposta) => {
        const idPixel = resposta.data[0].vl;
        this.loadFacebookPixel(idPixel);
      });
      var cd = "ORDEM_ALFABETICA";
      Inis.listarInisCd(cd).then((response) => {
        this.ordemAlfabetica = response.data[0].vl;
      });
      var cd = "PIZZA";
      Inis.listarInisCd(cd).then((response) => {
        this.tipoPizza = response.data[0].vl;
      });
    },

    listandoordem(ord) {
      Ordem.listandoordem(ord).then((resposta) => {
        this.nome_ordens = resposta.data;
      });
    },
    listar() {
      if (
        this.$route.query.serie != undefined &&
        this.$route.query.num_serie != undefined
      ) {
        localStorage.setItem(
          "serie" + localStorage.getItem("contrato"),
          this.$route.query.serie
        );
        localStorage.setItem(
          "num_serie" + localStorage.getItem("contrato"),
          this.$route.query.num_serie
        );
      }

      this.$store.dispatch("fetchProducts", { self: this });
    },
    loadFacebookPixel(idPixel) {
      // Crie o elemento <script> para carregar o Pixel
      var script = document.createElement("script");
      script.src = "https://connect.facebook.net/en_US/fbevents.js";
      script.async = true;

      // Adicione o Pixel ID à chamada de inicialização do Pixel
      var initCode = 'fbq("init", "' + idPixel + '");';

      // Crie o elemento <noscript> para o caso de o usuário não ter JavaScript habilitado
      var noscript = document.createElement("noscript");
      var img = document.createElement("img");
      img.height = 1;
      img.width = 1;
      img.style.display = "none";
      img.src =
        "https://www.facebook.com/tr?id=" + idPixel + "&ev=PageView&noscript=1";

      // Adicione o código de inicialização ao elemento <noscript>
      noscript.appendChild(document.createTextNode(initCode));
      noscript.appendChild(img);

      // Adicione os elementos ao DOM
      document.head.appendChild(script);
      document.head.appendChild(noscript);
    },
    ...mapActions(["addToCart"]),
  },
  mounted() {
    this.listandoInis(),
      this.listar(),
      this.listarclasse(),
      this.listandoordem();
  },
};
</script>
<style>
.promo-price {
  font-weight: bold; /* negrito, se desejar */
}

.risquinho {
  text-decoration: line-through;
  color: Gray;
}
</style>
